export type ROLES =
  | 'clinicadmin'
  | 'clinicuser'
  | 'caseadmin'
  | 'telehealthclinician'
  | 'testgrader'
  | 'vitaziadmin'
  | 'optometrist'
  | 'sales'
  | 'sandbox';

export const ROLES_LABELS: Record<string, string>[] = [
  { clinicadmin: 'Organization Admin' },
  { clinicuser: 'Organization User' },
  { caseadmin: 'Case Admin' },
  { telehealthclinician: 'Telehealth Clinician' },
  { vitaziadmin: 'Vitazi Admin' },
  { optometrist: 'Optometrist' },
  { sales: 'Sales' },
  { sandbox: 'Sandbox' },
];
